import React from 'react'
import './help_form.scss'
import { Row, Col, Button } from 'react-bootstrap'
import Form from 'react-bootstrap/Form';
import { images } from '../../../utils/customFn';
const HelpForm = () => {
    return (
        <div className='help_form'>
            <div className='bussiness_form'>
                <Row>
                    <Col sm={12} md={8} lg={8} xl={8}>
                        <div className='talk-form-main'>
                            <div className='top-heading'>
                                <h4 className='sub_heading'>How can we help you and your employees?</h4>
                                <p>Tell us a little bit about you and your company and we’ll reach out to you for next steps. We look forward to having a conversation about how we can help you provide a retirement plan for you and your employees.</p>
                            </div>
                            <Form>
                                <Row>
                                    <Col sm={12} md={6} lg={6} xl={6}>
                                        <Form.Group className="mb-3" controlId="formBasicEmail">
                                            <Form.Label>Email*</Form.Label>
                                            <Form.Control type="text" />
                                        </Form.Group>
                                    </Col>
                                    <Col sm={12} md={6} lg={6} xl={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Company name*</Form.Label>
                                            <Form.Control type="text" />
                                        </Form.Group>
                                    </Col>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Email address*</Form.Label>
                                        <Form.Control type="text" />
                                    </Form.Group>
                                    <Col sm={12} md={6} lg={6} xl={6}>
                                        <Form.Group className="mb-3" controlId="formBasicEmail">
                                            <Form.Label>Industry*</Form.Label>
                                            <Form.Control />
                                        </Form.Group>
                                    </Col>
                                    <Col sm={12} md={6} lg={6} xl={6}>
                                        <Form.Group className="mb-3" >
                                            <Form.Label>Number of employees*</Form.Label>
                                            <Form.Control type="text" />
                                        </Form.Group>
                                    </Col>
                                    <Col sm={12}>
                                        <Form.Group className="mb-3" >
                                            <Form.Label>Do you currently offer a 401(k) at your business?*</Form.Label>
                                            <Form.Control type="text" />
                                        </Form.Group>
                                    </Col>
                                    <Col sm={12} className='mb-3'>
                                        <Form.Group className="mb-0">
                                            <Form.Label>Comments</Form.Label>
                                            <Form.Control as="textarea" rows={7} className='mb-0' />
                                        </Form.Group>
                                        <span className='small_text right'>0/2000</span>
                                        <span className='small_text'>Please don’t provide sensitive personal information (e.g., your Social Security number, date of birth, or driver’s license number). If we need additional information, we’ll contact you directly. Thank you.
                                        </span>
                                    </Col>
                                </Row>
                                <div className='term-condition'>
                                    <p>By pressing submit form, you agree that the information you are providing is your own and we may use the information you provide according to our <a href="https://www.sentry.com/privacy-policy" rel="noopener noreferrer" target="_blank">Privacy Policy</a> and <a href="https://www.sentry.com/terms-and-conditions" rel="noopener noreferrer" target="_blank">Terms &amp; Conditions</a>.</p>
                                </div>
                                <div className='bottom-btn'>
                                    <Button className='submit-btn' type="submit">
                                        Submit form
                                    </Button>
                                </div>
                            </Form>
                        </div>
                        <div className='form_descrption'>
                            <p>**Assets and policyholder surplus are as of Dec. 31, 2023, and represent the aggregate total for all members of the Sentry Insurance Group and are not reflective of any individual underwriting company.</p>
                            <p className='mb-0'>Life insurance and annuities are issued and administered by Sentry Life Insurance Company, Stevens Point, WI. In New York, life insurance and annuities are issued and administered by Sentry Life Insurance Company of New York, Syracuse, NY. Policies, coverages, and benefits are not available in all states. See contract for complete details: (Group Annuity) 840-300; (Group Annuity) 840-300(NY).</p>
                        </div>
                    </Col>
                    <Col sm={12} md={4} lg={4} xl={4}>
                        <div className='media-img'>
                            <img src={images['icon_of_two_people_seating_talking.svg']} alt="media" />
                        </div>
                    </Col>
                </Row>
            </div>
        </div>
    )
}

export default HelpForm;